interface EmptyStateProps {
  title?: string;
  desc?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  title = "暂无匹配内容",
  desc = "当前筛选条件下没有找到相关资讯，试试调整筛选条件或重置。",
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4 bg-background-50 border border-dashed border-background-300 rounded-lg">
      <span className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center mb-4">
        <i className="ri-inbox-2-line text-3xl text-foreground-400" />
      </span>
      <h3 className="font-heading font-semibold text-lg text-foreground-900">{title}</h3>
      <p className="mt-2 text-sm text-foreground-500 max-w-md">{desc}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 h-10 px-5 rounded-md bg-primary-600 text-background-50 text-sm hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}